import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles/modal.module.css'
import UserContext from '../context/user/UserContext';
import StateContext from '../context/state/StateContext';
import { toast } from 'react-toastify';
import Loading from './Loading';

const AddGroup = (props) => {

    const { getEmployees } = useContext(UserContext);
    const { employees, setLoading, groups, setGroups, setModal } = useContext(StateContext);
    const [disabled, setDisabled] = useState(true);
    const [groupName, setGroupName] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [error, setError] = useState(null);
    const [groupDetails, setGroupDetails] = useState(null); // State to hold group details

    useEffect(() => {
        getEmployees(); // Fetch employees via context function
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setLoading({ open: true, text: "Adding" })
            const response = await fetch(process.env.REACT_APP_API_URL + 'api/group/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    name: groupName,
                    userIds: selectedUsers,
                }),
            });
            let result = await response.json();
            if (response.ok) {
                toast.success('Group created successfully');
                setGroupName('');
                setSelectedUsers([]);
                setGroups(groups => [...groups, result.group]);
                setModal({ open: false, component: "" })
            } else {
                const error = await response.json();
                setError('Failed to create group: ' + error.message)
                toast.error('Failed to create group: ' + error.message);
            }
        } catch (error) {
            console.error('Error creating group:', error);
            toast.error('Error creating group:', error);
        } finally{
            setLoading({ open: false, text: "" })
        }
    };

    const handleUserSelection = (userId) => {
        setSelectedUsers((prevSelected) =>
            prevSelected.includes(userId)
                ? prevSelected.filter((id) => id !== userId)
                : [...prevSelected, userId]
        );
    };

    return (
        <>
        <Loading />
            <div className={styles.head}>
                <h3>Add Group</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <form action="" onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className={"inputField"}>
                        <input
                            type="text"
                            id="groupName"
                            value={groupName}
                            placeholder='Add Group Name'
                            onChange={(e) => {setGroupName(e.target.value); setDisabled(false)}}
                            required
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label htmlFor="" className='mb-1 label fw-semibold'>Select Users:</label>
                        <div style={styles.userList}>
                            {employees &&
                                employees.map((item, index) => (
                                    <div key={index} className="checkbox-wrapper-4">
                                        <input
                                            type="checkbox"
                                            checked={selectedUsers.includes(item.id)}
                                            onChange={() => {handleUserSelection(item.id); setDisabled(false)}}
                                            id={`user-${item.id}`}
                                            className="inp-cbx"
                                        />
                                        <label htmlFor={`user-${item.id}`} className="cbx">
                                            <span><svg></svg></span>
                                            <span className='text'>{item.name}</span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Add</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddGroup
